import React from 'react'
import Card from './Card';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useState } from 'react';
import { useTranslation } from "react-i18next";


const Testimonials = (props) => {
    const { t } = useTranslation();
    let reviews = props.reviews;
    const [index, setIndex] = useState(0);

    function leftShiftHandler() {
        if(index - 1 < 0) {
            setIndex(reviews.length - 1);
        }
        else {
            setIndex(index - 1);
        }
    }

    function rightShiftHandler() {
        if(index + 1 >=reviews.length) {
            setIndex(0);
        }
        else {
            setIndex(index+1);
        }

    }
  
  return (
        <div className='impact-testimonials-shell'>
            <Card review={reviews[index]} />

            <div className='impact-testimonials-nav' aria-label={t('testimonialsPage.a11y.navigation')}> 
                <button
                    type='button'
                    onClick={leftShiftHandler}
                    className='impact-testimonials-btn'
                    aria-label={t('testimonialsPage.a11y.previous')}
                >
                    <FiChevronLeft />
                </button>
                <button
                    type='button'
                    onClick={rightShiftHandler}
                    className='impact-testimonials-btn'
                    aria-label={t('testimonialsPage.a11y.next')}
                >
                    <FiChevronRight />
                </button>
            </div>
        </div>
  )
}

export default Testimonials
